import React from 'react'

import type { Variant } from '../../../../themes'
import type { IconName } from '../../../core'
import { Text } from '../../../core'
import Counter from '../../../core/Counter/Counter'
import { Flex, Inline } from '../../../layout'
import type { MenuEntryConfig } from './MenuEntry.styles'
import { StyledMenuEntry, StyledMenuEntryIcon } from './MenuEntry.styles'

export interface MenuEntryProps {
  'data-e2e'?: string
  className?: string
  config?: MenuEntryConfig
  count?: number
  hasChevron?: boolean
  icon?: IconName
  isActive?: boolean
  label: string | React.ReactNode
  onClick?: () => void
  variant?: Variant
}

const MenuEntry = ({
  'data-e2e': dataE2e = 'menu-entry',
  className,
  config,
  count,
  hasChevron = false,
  icon,
  isActive = false,
  label,
  onClick,
  variant,
}: MenuEntryProps) => {
  const renderLabel = () =>
    typeof label === 'string' ? (
      <Text size="large" ellipsis noWrap={!icon}>
        {label}
      </Text>
    ) : (
      label
    )

  const renderBaseEntry = () =>
    icon ? (
      <Inline spacing="small" alignment="center" noWrap>
        <StyledMenuEntryIcon
          data-e2e={`${dataE2e}--icon`}
          name={icon}
          size="lg"
          faStyle="far"
          variant={variant}
        />
        {renderLabel()}
      </Inline>
    ) : (
      renderLabel()
    )

  return (
    <StyledMenuEntry
      className={className}
      config={config}
      data-menu={hasChevron ? 'menu-entry-contextual-menu' : 'menu-entry'}
      data-e2e={isActive ? `${dataE2e}--is-active` : dataE2e}
      isActive={isActive}
      onClick={onClick}
      variant={variant}
    >
      {hasChevron || !!count ? (
        <Flex alignment="center" fluid>
          {renderBaseEntry()}
          <Inline alignment="center" noWrap>
            <Counter data-e2e={`${dataE2e}--counter`} count={count} />
            {hasChevron && (
              <StyledMenuEntryIcon
                data-e2e={`${dataE2e}--chevron`}
                name="chevron-right"
                faStyle="fas"
                variant={variant}
              />
            )}
          </Inline>
        </Flex>
      ) : (
        renderBaseEntry()
      )}
    </StyledMenuEntry>
  )
}

export default MenuEntry
